/* NgRx */
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SharedState } from './shared.reducer';

// Selector functions
const sharedData = createFeatureSelector<SharedState>('sitenotes.shared');

export const isLoading = createSelector(sharedData, state => state.loading);

export const appDataDetails = createSelector(sharedData, state => state.appDataDetails);

export const workConditions = createSelector(sharedData, state => state.workConditions);

export const weatherConditions = createSelector(sharedData, state => state.weatherConditions);

export const limits = createSelector(sharedData, state => state.limits);

export const searchResultsInfo = createSelector(sharedData, state => state.searchResultsInfo);

export const widgetConfig = createSelector(sharedData, state => state.widgetConfig);

export const dailyReportLocationConfig = createSelector(sharedData, state => state.dailyReportLocationConfig);

export const translations = createSelector(sharedData, state => state.translations);

export const offsetTypes = createSelector(sharedData, state => state.offsetTypes);

export const weatherFields = createSelector(sharedData, state => state.weatherFields);

export const exprEvalConfig = createSelector(sharedData, state => state.exprEvalConfig);
